import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { MainRoutes } from './components/MainRoutes';
import './global.css';

ReactDOM.render(<MainRoutes />, document.getElementById('root'));
